import { ProcessColumnIdentifier } from "./ProcessList";
import { ProcessWithStatus } from "./ProcessWithStatus";

export const visibleProcessListColumnsKey = "frends_processList_visibleColumns";
export const visibleSubprocessListColumnsKey = "frends_subprocessList_visibleColumns";

const defaultSubprocessListCols: Array<keyof (ProcessWithStatus)> =
    [ProcessColumnIdentifier.name, ProcessColumnIdentifier.tags];

const defaultProcessListCols: Array<keyof (ProcessWithStatus)> = [
    ProcessColumnIdentifier.name, ProcessColumnIdentifier.tags,
    ProcessColumnIdentifier.executionsPerDay, ProcessColumnIdentifier.triggers
];

export const maxVisibleColumns = 10;

export function getVisibleColumnsFromStore(isSubprocessList: boolean): Array<keyof (ProcessWithStatus)> {
    const visibleColumnsKey = isSubprocessList ? visibleSubprocessListColumnsKey : visibleProcessListColumnsKey;
    const colsValueInStore = localStorage.getItem(visibleColumnsKey);
    if (!colsValueInStore || !colsValueInStore.startsWith("[")) {
        return isSubprocessList ? defaultSubprocessListCols : defaultProcessListCols;
    }
    return JSON.parse(colsValueInStore);
}

export function setVisibleColumnsToStore(isSubprocessList: boolean, visibleColumns: Array<keyof (ProcessWithStatus)>) {
    const visibleColumnsKey = isSubprocessList ? visibleSubprocessListColumnsKey : visibleProcessListColumnsKey;
    localStorage.setItem(visibleColumnsKey, JSON.stringify(visibleColumns));
}
